import { RECURSOS } from '../dados/recursos';
import { Secao } from './secao';
import { Reveal, RevealGrupo } from './reveal';
import { CartaoBento } from './cartao-bento';

/** Quatro cartões iguais, dois por linha a partir do `sm`. */
export function RecursosBento(): JSX.Element {
  return (
    <Secao
      adiarRender
      alturaEstimada={1150}
      id="recursos"
      rotulo="Recursos"
      titulo={
        <>
          Cada defeito do Word tem uma razão para{' '}
          <span className="font-semibold">não existir</span> aqui.
        </>
      }
    >
      {/* Peso LEVE, e não o padrão: são cinco cartões de leitura rápida, e o
          gesto forte pertence ao cabeçalho que os anuncia. */}
      <RevealGrupo className="mt-12 grid gap-4 sm:grid-cols-2">
        {/* DOIS por linha, todos do mesmo tamanho — decisão do dono depois de
            ver no ar: o cartão largo tinha 1104px com a cena de 304px boiando
            no meio, e o que sobrava era espaço morto. Com quatro quadros
            iguais a cena preenche cada um. */}
        {RECURSOS.map((recurso) => (
          <Reveal key={recurso.titulo} peso="leve">
            <CartaoBento recurso={recurso} />
          </Reveal>
        ))}
      </RevealGrupo>
    </Secao>
  );
}
